import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';

const StockInventory = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [datagroupby, setDatagroupby] = useState([]);
  const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(161)); 
console.log(permission);
let para ={season_id:season_id};
    axios.post("/stock-inventories/listing",para,{ headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        setData(response.data.data.stocks);
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });

      axios.post("/stock-inventories/listing-groupby-date-location",para,{ headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        setDatagroupby(response.data.data.stocks);
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });

    }, []);


  
const deleteItem = (item) => {

  Swal.fire({
    title: 'Do you really want to delete this record?',
    //text: 'This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'DELETE'
  }).then((result) => {
    if (result.isConfirmed) {
      axios.get(`/stock-inventories/delete/${season_id+'-'+item}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/stock-inventories";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          }); 
         }
  });
}

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


    
  //  ];
  // 🔹 Separate Cell component for Location
const LocationCell = ({ row }) => {
  const locationTitle = row.original?.location_detail?.title || '';
  return (
    <a
      href={`/stock-inventories-groupby-location-date/${row.original?.location}_${row.original?.date}`}
      className=""
    >
      {locationTitle}
    </a>
  );
};

// 🔹 Separate Cell component for Date
const DateCell = ({ row }) => (
  <a
    href={`/stock-inventories-groupby-location-date/${row.original?.location}_${row.original?.date}`}
    className=""
  >
    {row.original?.date}
  </a>
);

// ✅ Define PropTypes
LocationCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      location: PropTypes.string, // Ensure location is a string
      date: PropTypes.string, // Ensure date is a string
      location_detail: PropTypes.shape({
        title: PropTypes.string, // Ensure title is a string
      }),
    }),
  }).isRequired,
};

DateCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      location: PropTypes.string,
      date: PropTypes.string,
    }),
  }).isRequired,
};

// 🔹 Column Configuration
const columnss = [
  {
    header: 'Location',
    Cell: LocationCell, // ✅ Use separate component
  },
  {
    header: 'Date',
    Cell: DateCell, // ✅ Use separate component
  },
];


  const columns =[
   
 
    {
      header: 'Location',
      accessorFn: (row) => `${(row.location_name)?row.location_name:""} `,
    },  

    {
      accessorKey: 'date', //normal accessorKey
      header: 'Date',
    },
   
    {
      header: 'Consumable',
      accessorFn: (row) => `${(row.consumable_product)?row.consumable_product.consumable_name:""} `,
    },  
    
    {
      accessorKey: 'quantity',
      header: 'Quantity',
    },
    {
      accessorKey: 'note',
      header: 'Note',
    },
   
    
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   ];


  

  const editItem = (item)=>{
    window.location.href = "/stock-inventories-edit/"+item;
  }

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Stock Inventories</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Stock Inventories</li>
                </ul>
              </div>
              <div className="col-auto">
                 {permission && permission.add == 1 && (
                      <Link to="/stock-inventories-add" className="btn btn-primary me-1">
                      <i className="fas fa-plus"></i>
                    </Link>
                  )} 
                
              </div>
            </div>
          </div>


          <div className="row">
            
          <div className="col-md-12">
           <div className="card bg-white">
                {permission && permission.list == 1 && (


              <div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-bottom">
                      
                    
                      <li className="nav-item">
                          <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">Stock Inventories Group By Location and Date</a>                                  
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Stock Inventories  Listing</a>                                   
                      </li>                    
                      </ul>
                      <div className="tab-content">
                    
                      <div className="tab-pane show active" id="listing-groupby-supplier">
                      <div className="row"   id="listing-followup">
                        <div className="col-sm-12">
                          <div className="card card-table">
                            <div className="card-body">
                                <div className="table-responsive">

                                <MaterialReactTable columns={columnss} data={datagroupby} 
                                    enableColumnOrdering
                                    enablePinning
                                  />
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        
                        </div>                                
                        <div className="tab-pane  " id="listing-all">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">
                                    <MaterialReactTable columns={columns} data={data} 
                                        enableColumnOrdering
                                        enablePinning
                                        enableRowActions
                                        //renderColumnActionsMenuItems 
                                        renderRowActionMenuItems={({ row }) => [
                                          permission?.update == 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original.stock_inventory_id)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete == 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                      />
                                    
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        
                        </div>                                
                      
                      </div>                             
                  </div>


            
                )}

          
           </div>
       </div>
     

            
          </div>
        </div>
      </div>
    </div>
  );
};
export default StockInventory;
